<template>
    <!-- 账号管理 -->
    <div>
        <el-card class="box-card box-cards" shadow="never">
            <el-row>
                <el-form :inline="true" class="user-search">
                    <el-col :span="24">
                        <el-form-item>
                            <div class="card_top"><span>修改密码</span></div>
                        </el-form-item>

                    </el-col>
                </el-form>
            </el-row>
        </el-card>
        <el-card class="box-card box-cards2" shadow="never">
            <div class="demo-drawer__content">
                <el-row :gutter="20">
                    <el-form label-width="110px">

                        <el-col :span="10" :offset="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="当前密码" prop="oldPassword" label-width="200px">
                                    <el-input v-model="oldPassword" show-password></el-input>
                                </el-form-item>
                                <el-form-item label="新密码" prop="newPassword" label-width="200px">
                                    <el-input v-model="newPassword" show-password></el-input>
                                </el-form-item>
                                <el-form-item label="确认新密码" prop="confirmPassword" label-width="200px">
                                    <el-input v-model="confirmPassword" show-password></el-input>
                                </el-form-item>
                                <el-form-item label-width="200px">
                                    <el-button size="small" type="goon" class="title" @click="submitForm('editForm')">
                                        保存</el-button>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-form>
                </el-row>

                <div style="height: 60px; margin-top: 50px"></div>
            </div>

        </el-card>
    </div>
</template>
<script>
import { managerscgmypwd } from "../../api/userMG";
export default {
    data() {
        return {
            formInline: {
                data: {},
                params: {},
            },
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
        };
    },
    created() {

    },
    methods: {
        submitForm(info) {
            if (this.newPassword != this.confirmPassword) {
                this.$message({
                    type: "info",
                    message: "两次密码输入不一致",
                });
                return;
            }
            managerscgmypwd({
                data: {},
                params: {
                    old_password: this.oldPassword,
                    password: this.newPassword
                },
            })
                .then(res => {
                    if (res.code == 200) {
                        this.$message({
                            message: "修改成功！",
                            type: "success",
                        });
                    } else {
                        this.$message({
                            type: "info",
                            message: res.message,
                        });
                    }
                })
                .catch((err) => {
                    this.$message.error("保存失败，请稍后再试！");
                });
        }

    },
};
</script>
<style>
@import "../../assets/css/index.css";

.title {}
</style>


// WEBPACK FOOTER //
// src/views/managers/password.vue